export default "__VITE_ASSET__BU8_KeaA__"